import { defaultTheme } from 'gd-design-library';
import { colors } from './colors';
import { font } from './font';

export const price = {
  ...defaultTheme.price,
  default: {
    fontFamily: font.family,
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  currentPrice: {
    default: {
      fontSize: '18px',
      color: '#111',
      lineHeight: '20px',
      fontWeight: 400
    }
  },
  oldPrice: {
    default: {
      fontSize: '18px',
      lineHeight: '20px',
      fontWeight: 400,
      color: colors.neutral['grey.90'],
      textDecoration: 'line-through'
    }
  }
};
